<!-- Divider -->
<div class="expepharma-vertical-navigation-item-wrapper divider" [ngClass]="item.classes?.wrapper"></div>
